import React from 'react'
import AnchorLink from 'react-anchor-link-smooth-scroll'
import { Container, Button } from 'Common'
import dev from 'Static/illustrations/aboutme.svg'
import { Wrapper, SkillsWrapper, Details, Thumbnail } from './styles'

export const About = () => (
	<Wrapper id="about">
		<SkillsWrapper as={Container}>
			<Thumbnail>
				<img src={dev} alt="I’m a Frontend Developer!" />
			</Thumbnail>
			<Details>
				<h1>About Me</h1>
				<p>
					I am a Front-end Developer, graduate of BITS Pilani, India. I spent
					the last 6 years working both as a front-end developer and full-stack
					developer and as part of a team in various companies/clients across
					Netherlands, USA, UK and India. I acquired project and time management
					skills, as well as the ability to communicate with team members and
					clients while effectively meeting milestones and deadlines.
				</p>
				{/* <p>
					I develop fast interactive front ends, using the latest technologies
					and techniques to reduce page load time. I use my knowledge and tools
					to save time in development.
				</p> */}
				<p>
					I love the web and techy things and computers and what makes them
					tick. I constantly look for new ways to do my work, new programs, new
					sites and new methodologies. I won’t let my tools slow me down, and I
					can fix them when they break. I’m not saying I can debug a crashing
					Dreamweaver, but only because I haven’t coded assembly in a few years.
				</p>

				<p>
					When I'm not writing code, I'm probably binge watching netflix with my
					husband or grooving on Bollywood songs.
				</p>

				{/* <p>
					I'm available for remote work - if you would like to build something
					together, get in touch?
				</p> */}
				{/* <Button as={AnchorLink} href="#contact">
					Email Me
				</Button> */}
			</Details>
		</SkillsWrapper>
	</Wrapper>
)
